// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Ma7z","amount":"Amount_amount__23feH","tip":"Amount_tip__2ByA_","tipHeader":"Amount_tipHeader__1aqG_","tipsWrap":"Amount_tipsWrap__2eun4"};